import React, { useEffect, useState } from "react";
import "./css.css";
import { useNavigate } from "react-router-dom";

/**
 * @author
 * @function Login
 *
 **/

 export const Screenlimit = (props) => {
    // const [pic, setPic] = useState(img1);
    const history = useNavigate();
    const [url, setUrl] = useState(window.location.href);
    const [userId, setUserId] = useState("");

    useEffect(() => {
        const iosa = url.split(",");
        setUserId(iosa[1]);
      }, []);    
    
    return(
        <div className="main">
            <div className="text-center">
                <div className="thankyoumessage">
                    <h2>Please use an ipad/computer screen in order to conduct the study.</h2>
                </div>
            </div>
        </div>
    );
}